import DatastoreTypeHandler from './DatastoreTypeHandler'
import { requiredFileRule } from './helpers'

export default class ShapefileDatastoreHandler extends DatastoreTypeHandler {
  constructor() {
    super('shapefile')
  }

  fileRules() {
    return [requiredFileRule]
  }

  validateCreate(data, context = {}) {
    if (!data.file) {
      return {
        ok: false,
        errors: { file: ['File không thể bỏ trống'] },
      }
    }
    if (context.isCreate && (context.srs === null || context.srs === undefined || context.srs === '')) {
      return {
        ok: false,
        errors: { srs: ['Hệ tọa độ không thể bỏ trống'] },
      }
    }
    return { ok: true, errors: {} }
  }

  buildCreatePayload(data, context = {}) {
    const payload = super.buildCreatePayload(data, context)
    payload.srs = context.srs
    payload.file = data.file
    return payload
  }
}
